<template>
    <div class="card-map  card-map--bordered card-map--sm-space-top"
        :style="{'background': `url(${image_preview}) right top no-repeat`}">
        <div class="mm-mask mm-mask--right" :class="maskClassName"></div>
        <div class="card-map__body card-map__body--vertical box--space-top box--space-horizontal">
            <div class="card-map__description card-map__description--no-padding">
                <div class="row">
                    <span class="col col-md-7 card-map__title card-map__title--l">
                        {{title}}
                    </span>
                </div>
                <div class="row" v-if="previewText">
                    <span class="col col-md-7 card-map__subtitle card-map__subtitle--l">
                        {{previewText}}
                    </span>
                </div>
                <slot name="content">

                </slot>
            </div>
            <div class="card-map__btns">
                <router-link class="button button--l normal--button button--small-text button--uppercase button--shadow"
                    :to="to">
                    Zobrazit
                </router-link>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    name: "PostPreview",
    props: {
        id: {
            type: String,
            required: true
        },
        title: {
            type: String,
            required: true
        },
        previewText: {
            type: String
            //required: true
        },
        attachments: {
            type: Array
        },
        to: {
            type: Object,
            required: true
        },
        imagePreview: {
            type: String,
            required: false
        },
        maskClassName: {
            type: String
        }
    },
    computed: {
        image_preview() {
            if (this.imagePreview) {
                return this.imagePreview;
            }

            if (this.attachments) {
                var image = this.attachments.find(item => item.type === "preview-image");
                if (image) {
                    return `https://mm_cms.emis-online.sk/cms/web_cms_apigateway/api/Pages/pages/attachment/${image.attachmentKey}`;
                }
            }
            return null;
        }
    }
};
</script>